export default {
      id: "cake-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#cake",
      toString: function () {
        return this.url;
      }
    }